module.exports = __webpack_public_path__ + "img/1596299577.68d86778.jpg";